import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {RestService} from '../services/rest.service';
import {UIBlockerService} from '../services/uiblocker.service';
import {Router} from '@angular/router';
import {DataService} from '../services/data.service';
import {SessionStorageService} from '../services/session-storage.service';
import {finalize} from 'rxjs/operators';
import {TranslationService} from '../services/translation.service';
import {AdminUser} from '../models/api.models';
import {isNullOrUndefined} from '../shared/is-null-or-undefined';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnChanges {
    readonly isNullOrUndefined = isNullOrUndefined;

    @Input() userInfo?: AdminUser;
    language = 'ro';
    isSavingLanguage = false;

    constructor(
        private restService: RestService,
        private uiBlockerService: UIBlockerService,
        private router: Router,
        private dataService: DataService,
        private localStorage: SessionStorageService,
        private translationService: TranslationService
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.userInfo && this.userInfo) {
            this.language = this.userInfo.Language === 'en' ? 'en' : 'ro';
            this.translationService.setLanguage(this.language);
        }
    }

    changeLanguage(language: string) {
        if (!this.userInfo || this.isSavingLanguage) {
            return;
        }

        const previousLanguage = this.language;
        this.language = language === 'en' ? 'en' : 'ro';
        this.translationService.setLanguage(this.language);
        this.isSavingLanguage = true;

        this.restService.updateAdminProfile({
            Name: this.userInfo.Name,
            Email: this.userInfo.Email,
            Language: this.language,
            CurrentPassword: '',
            NewPassword: '',
            NewPasswordConfirmation: ''
        }).pipe(
            finalize(() => {
                this.isSavingLanguage = false;
            })
        ).subscribe({
            next: (response) => {
                if (this.dataService.isResponseSuccessful(response) && response.UserInfo) {
                    this.dataService.setUserInfo(response.UserInfo);
                    return;
                }

                this.language = previousLanguage;
                this.translationService.setLanguage(previousLanguage);
            },
            error: () => {
                this.language = previousLanguage;
                this.translationService.setLanguage(previousLanguage);
            }
        });
    }

    openProfile() {
        void this.router.navigate(['/central/profile']);
    }

    logOutClicked() {

        this.deleteSessionFromLocalStorage();

        this.removeSessionIdFromServer();

        void this.router.navigate(['/login']);
    }

    deleteSessionFromLocalStorage() {

        this.localStorage.clear().subscribe(() => undefined);
    }

    removeSessionIdFromServer() {
        this.restService.logout()
            .pipe(
                finalize(() => {
                    this.uiBlockerService.unBlockUI();
                })
            ).subscribe(() => undefined);
    }

}
